<app-wizard-wrapper
    [steps]="steps"
    [title]="'Initialize Political Rate-Card'"
    [backwardText]="backwardText"
    [forwardText]="forwardText"
    [stepCount]="stepCount"
    [dialogRef]="dialogRef"
    [submitCallback]="populateRates.bind(this)"
    [forwardValidation]="forwardValidation"
    [showStepName]="false"
    [isLoadingForward]="isLoading"
    (tabChanged)="tabChanged($event)"
    class="political-popup-wrapper"
>
    <!-- Step 1 -->
    <div
        *ngIf="stepCount === setupTab.step1"
        class="margin-left-right"
    >
        <div>
            <div class="step-title bold-font">Step 1: Select Elections & Stations to Set Up</div>
            <div class="margin-bottom-1-em">
                <app-filter-input [property]="politicalWindows"></app-filter-input>
                <div class="wizard-filter-tab">
                    <app-filter-input [property]="markets"></app-filter-input>
                </div>
                <div class="wizard-filter-tab">
                    <app-filter-input [property]="stations"></app-filter-input>
                </div>
            </div>
        </div>
        <!-- Only shown when the selected window(s)/channel(s) are already initialized -->
        <div
            *ngIf="selectionAlreadyInitialized"
            class="margin-bottom-1-em setup-mode-wrapper"
        >
            <app-filter-input [property]="rateSetupModeFilter"></app-filter-input>
            <app-filter-input
                *ngIf="useExistingSettings()"
                [property]="existingSettingsScopeFilter"
            ></app-filter-input>
        </div>

        <div
            *ngIf="!useExistingSettings()"
            class="margin-bottom-1-em"
        >
            <div class="step-title bold-font">Step 2: Set Rates</div>
            <mat-radio-group
                aria-label="Select an option"
                [(ngModel)]="rateProcessOption"
            >
                <div>
                    <mat-radio-button
                        class="margin-top-75-em margin-bottom-1-em bold-font"
                        [value]="rateStructureType.defineRates"
                        >Define Rate Rules</mat-radio-button
                    >
                </div>
                <div>
                    <mat-radio-button
                        class="margin-top-75-em margin-bottom-1-em bold-font"
                        [value]="rateStructureType.copyWindow"
                        >Copy Rates from another Political Window</mat-radio-button
                    >
                    <app-filter-input
                        *ngIf="isCopyWindow()"
                        [property]="copyPoliticalWindows"
                        [hideOptions]="politicalWindows.Value"
                    ></app-filter-input>
                    <p *ngIf="copyPoliticalWindows.Value && isCopyWindow()">
                        *Rates for any programs that do not exist in the copied political window will need to be manually added to the new
                        window.
                    </p>
                    <div
                        *ngIf="isCopyWindow()"
                        class="step-title bold-font margin-bottom-1-em"
                    >
                        Step 3.1: Would you like to set the candidates rates to the LUR if it exists for the class of time/week?
                        <app-filter-input [property]="useLURFilter"></app-filter-input>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <!-- Step 2 -->
    <div
        *ngIf="stepCount === setupTab.step2"
        class="margin-left-right"
    >
        <div>
            <div class="initial-rates bold-font">Step 3: Define Rules to Set Up Initial Rates</div>
            <div>
                <div>
                    <span>What spot lengths are included on political rate card?</span>
                    <app-filter-input
                        class="wizard-filter-tab"
                        [property]="spotLengths"
                    ></app-filter-input>
                </div>
                <div>
                    <span>Do you set rates per Week or for the whole Window?</span>
                    <app-filter-input [property]="periodLevel"></app-filter-input>
                </div>
                <div class="step-title bold-font margin-bottom-1-em">
                    Step 3.1: Would you like to set the candidates rates to the LUR if it exists for the class of time/week?
                    <app-filter-input [property]="useLURFilter"></app-filter-input>
                </div>
                <div class="step-title bold-font">
                    Step 3.2: For all rates that do not have an existing LUR, how would you like to set these rates?
                </div>
                <div class="step-title bold-font margin-bottom-1-em">
                    *multipliers are used to automatically keep rates aligned to your desired tier. For example, enter "2" to keep that rate
                    two times the value of your desired tier.
                </div>
                <ag-grid-angular
                    class="ag-theme-material"
                    [rowData]="rows"
                    [columnDefs]="colDefs"
                    (gridReady)="onGridReadyCustomizeWidth($event)"
                    (gridColumnsChanged)="gridApi?.autoSizeAllColumns()"
                    [suppressColumnVirtualisation]="true"
                    [suppressContextMenu]="true"
                    [overlayNoRowsTemplate]="overLayNoRowsTemplate"
                    [domLayout]="'autoHeight'"
                    domLayout="autoHeight"
                    (cellEditingStarted)="onCellEditStart($event)"
                    (cellEditingStopped)="onCellEditStopped($event)"
                    [singleClickEdit]="true"
                    [stopEditingWhenCellsLoseFocus]="true"
                >
                </ag-grid-angular>
            </div>
        </div>
    </div>
</app-wizard-wrapper>
